// custom_modal_controller.js
import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["customModal", "dynamicContent"];

  initialize() {
    // Add event listener to close sidebar when clicking outside of sidebar-content
    document.addEventListener("click", this.handleClickOutside.bind(this));
  }

  async open() {
    this.customModalTarget.classList.add("open");
    const listingId = this.customModalTarget.getAttribute('data-listing-id');
    if (listingId != null) {
      await this.loadModalContent(listingId);
    }
  }

  close() {
    this.customModalTarget.classList.remove("open");
    const listingId = this.customModalTarget.getAttribute('data-listing-id');
    if (listingId != null) {
      this.dynamicContentTarget.innerHTML = ""; // Clear the modal content
    }
    this.removeQueryParam("variant");
  }

  handleClickOutside(event) {
    if (event.target.classList.contains('open')) {
      this.close();
    }
  }

  removeQueryParam(param) {
    const url = new URL(window.location);
    url.searchParams.delete(param);
    history.replaceState(null, "", url.pathname + url.search + url.hash);
  }

  async loadModalContent(listingId) {
    this.dynamicContentTarget.innerHTML = '<div class="text-center mt-5">Loading...</div>'
    try {
      const response = await fetch(`/listings/${listingId}/modal_content`);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.text();
      this.dynamicContentTarget.innerHTML = data;
      this.reinitializelazyLoad();
      this.reinitializeQuantityButtons();
      this.reinitializeSlick();
    } catch (error) {
      console.error("Failed to load modal content:", error);
    }
  }

  reinitializelazyLoad() {
    $("img").lazyload({
      failure_limit: Math.max(jQuery("img").length - 1, 0)
    });
  }

  reinitializeQuantityButtons() {
      $(".btn-num-product-down").on("click", function() {
        var numProduct = Number($(this).next().val());
        if (numProduct > 1) { // Ensure value doesn't go below 1
          $(this).next().val(numProduct - 1);
        }
      });
      
      $(".btn-num-product-up").on("click", function() {
        var numProduct = Number($(this).prev().val());
        $(this).prev().val(numProduct + 1);
      });
  }

  reinitializeSlick() {
    this.dynamicContentTarget.querySelectorAll(".wrap-slick3").forEach(function(el) {
      $(el)
        .find(".slick3")
        .slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          fade: true,
          infinite: true,
          autoplay: false,
          autoplaySpeed: 6000,
    
          arrows: true,
          appendArrows: $(el).find(".wrap-slick3-arrows"),
          prevArrow:
            '<button class="arrow-slick3 prev-slick3" name="button"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
          nextArrow:
            '<button class="arrow-slick3 next-slick3" name="button"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
    
          dots: true,
          appendDots: $(el).find(".wrap-slick3-dots"),
          dotsClass: "slick3-dots",
          customPaging: function(slick, index) {
            var portrait = $(slick.$slides[index]).data("thumb");
            return (
              '<img src="' +
              portrait +
              '"/><div class="slick3-dot-overlay"></div>'
            );
          }
        });
    });
  }
}
